import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import moment from 'moment-timezone';
import ProjectEditionButton from '../projectEditionButton/ProjectEditionButton';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const ProjectInformationView = props => {
  return /*#__PURE__*/_jsxs("div", {
    className: "col-4",
    children: [/*#__PURE__*/_jsx("h2", {
      children: /*#__PURE__*/_jsx(Translate, {
        value: "project.details.title"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "card h-100 flex-container column",
      children: props.error ? /*#__PURE__*/_jsx("span", {
        "data-id": "error-message",
        children: /*#__PURE__*/_jsx(Translate, {
          value: "error.generic"
        })
      }) : props.loading ? /*#__PURE__*/_jsx("span", {
        className: "loading-overlay"
      }) : props.project && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs("div", {
          className: "box border bottom",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex-container space-between",
            children: [/*#__PURE__*/_jsx("div", {
              className: "card-header font-size-l",
              children: /*#__PURE__*/_jsx(Translate, {
                value: "address.addressLine"
              })
            }), props.isProjectEditionAllowed && /*#__PURE__*/_jsx(ProjectEditionButton, {
              onEditButtonClick: props.onEditButtonClick
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "information",
            children: [`${props.project.address.addressLine},`, /*#__PURE__*/_jsx("br", {}), `${props.project.address.postCode} ${props.project.address.city}`]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "box border bottom",
          children: [/*#__PURE__*/_jsx("div", {
            className: "card-header font-size-l",
            children: /*#__PURE__*/_jsx(Translate, {
              value: "project.details.openingDate"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "information",
            children: moment(props.project.openingDate).format('DD/MM/YYYY')
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "box border bottom",
          children: [/*#__PURE__*/_jsx("div", {
            className: "card-header font-size-l",
            children: /*#__PURE__*/_jsx(Translate, {
              value: "project.details.closingDate"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "information",
            children: moment(props.project.closingDate).format('DD/MM/YYYY')
          })]
        })]
      })
    })]
  });
};
ProjectInformationView.defaultProps = {
  isProjectEditionAllowed: false,
  loading: true,
  error: false
};
ProjectInformationView.propTypes = {
  project: PropTypes.object,
  isProjectEditionAllowed: PropTypes.bool,
  error: PropTypes.bool,
  loading: PropTypes.bool,
  onEditButtonClick: PropTypes.func
};
export default ProjectInformationView;